import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { Header } from "../components/Header";
import { HeroSection } from "../components/HeroSection";
import { PlannerForm, BUDGETS, VIBES, todayISO } from "../components/PlannerForm";

const SURPRISE_CITIES = [
  "Austin", "New York", "Chicago", "Los Angeles", "Nashville", "Miami", "Denver",
  "Seattle", "Las Vegas", "New Orleans", "Atlanta", "Boston", "Philadelphia",
  "San Francisco", "Toronto", "London", "Portland", "San Diego", "Dallas", "Phoenix",
];

function randomPick(arr) {
  return arr[Math.floor(Math.random() * arr.length)];
}

function randomUpcomingDate() {
  const d = new Date();
  d.setDate(d.getDate() + 1 + Math.floor(Math.random() * 21));
  return d.toISOString().split("T")[0];
}

export default function Home() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ city: "", date: todayISO(), budget: "$$", vibe: "Casual" });
  const [loading, setLoading] = useState(false);
  const [surprising, setSurprising] = useState(false);

  const requestPlan = (payload) => navigate("/itinerary", { state: { pending: payload } });

  const planNight = () => {
    if (!form.city.trim()) {
      toast.error("Enter a city to plan your night.");
      return;
    }
    setLoading(true);
    requestPlan({ ...form, city: form.city.trim() });
  };

  const surpriseMe = () => {
    const pick = {
      city: randomPick(SURPRISE_CITIES),
      date: randomUpcomingDate(),
      budget: randomPick(BUDGETS).value,
      vibe: randomPick(VIBES),
    };
    setForm(pick);
    setSurprising(true);
    setTimeout(() => requestPlan(pick), 450);
  };

  return (
    <>
      <Header />
      <main className="relative overflow-hidden">
        <div className="pointer-events-none absolute inset-0 grid-noise opacity-60" />
        <div className="pointer-events-none absolute -top-40 left-1/2 h-96 w-96 -translate-x-1/2 rounded-full bg-primary/20 blur-[120px]" />
        <div className="pointer-events-none absolute top-40 right-0 h-80 w-80 rounded-full bg-accent/15 blur-[120px]" />

        <div className="relative max-w-3xl mx-auto px-4 sm:px-6 py-16 lg:py-24">
          <HeroSection />
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.55, delay: 0.15 }}
            className="mt-10 rounded-3xl border border-border bg-card p-6 sm:p-9 shadow-2xl glow"
          >
            <PlannerForm
              form={form}
              onChange={setForm}
              onPlan={planNight}
              onSurprise={surpriseMe}
              loading={loading}
              surprising={surprising}
            />
          </motion.div>
        </div>
      </main>
    </>
  );
}
